import {toast} from "react-toastify";

const defaultToastOptions = {
    position: 'bottom-right',
    autoClose: 15000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
};

const successNotify = (text, props) => {
    toast.success(text, Object.assign({}, defaultToastOptions, props));
}

export const errorNotify = (text, props = {}) => {
    toast.error(text, Object.assign({}, defaultToastOptions, props));
}

export const infoNotify = (text, props = {}) => {
    toast.info(text, Object.assign({}, defaultToastOptions, props));
}

export default successNotify;
